/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum InvestorInvitationStatus {
    NOT_INVITED = 'NOT_INVITED',
    INVITED = 'INVITED',
    ACTIVE = 'ACTIVE',
}
